const n = value => Number(value) || 0

export const documentCountSummary = (counts, hideDuplicates = true) => {
  if (!counts) return null
  const all = n(counts.totalWithDuplicates) || n(counts.total)
  const unique = n(counts.total)
  const shown = hideDuplicates ? unique : all
  const hidden = hideDuplicates ? Math.max(0, all - unique) : 0
  const noun = shown === 1 ? 'document' : 'documents'
  const text = hidden > 0
    ? `${shown.toLocaleString('en-GB')} ${noun} (${hidden.toLocaleString('en-GB')} ${hidden === 1 ? 'duplicate' : 'duplicates'} hidden)`
    : `${shown.toLocaleString('en-GB')} ${noun}`
  return { shown, hidden, text }
}
